import { initialSelectedEvent } from 'app/pages/TicketSalePage/slice/initialValues';
import { createSagaAction } from 'saga-toolkit';
import { vendorIdAndEventId } from 'types/commonPayloadTypes';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { EventPageState } from './types';

const sliceName = 'eventPage';

export const initialState: EventPageState = {
  event: initialSelectedEvent,
  loading: false,
};

export interface fetchEventPayload {
  meta: {
    arg: vendorIdAndEventId;
  };
}

export const fetchEvent = createSagaAction(`${sliceName}/fetchEvent`);

const eventPage = createSlice({
  name: sliceName,
  initialState,
  reducers: {},
  extraReducers: {
    [fetchEvent.pending]: state => ({
      ...state,
      loading: true,
    }),
    [fetchEvent.fulfilled]: (_, { payload }) => {
      const feesAndTaxes = payload.fees_and_taxes;
      delete payload.fees_and_taxes;

      return {
        event: { ...payload, ...feesAndTaxes },
        loading: false,
      };
    },
    [fetchEvent.rejected]: (state, { error }) => ({
      ...state,
      error,
      loading: false,
    }),
  },
});

export const { actions } = eventPage;

export const useEventSlice = () => {
  return { actions: eventPage.actions };
};

export default eventPage.reducer;
